import React from "react";
import Avatar from "components/Avatar";
import { FiMapPin, FiClock, FiCalendar } from "react-icons/fi";
import { convertFromUTC } from "utils/datetime";
import {
	formatSecondsToTime,
	calculateWorkTime,
	fixStartEndIntervals,
} from "utils/datetime";

const getTimeRange = (item) => {
	const raw_time_intervals = item.time_intervals_from_manual
		? item.time_intervals
		: item.shift.time_intervals;
	const time_intervals = fixStartEndIntervals(raw_time_intervals);

	if (!time_intervals || time_intervals.length === 0) return { range: "", total: "" };

	const starts = time_intervals.map((ti) => convertFromUTC(ti.start)).filter(Boolean);
	const ends = time_intervals.map((ti) => convertFromUTC(ti.end)).filter(Boolean);

	const rangeStart = starts.length > 0 ? starts[0] : "";
	const rangeEnd = ends.length > 0 ? ends[ends.length - 1] : "";
	const range = rangeStart && rangeEnd ? `${rangeStart}-${rangeEnd}h` : "";

	const totalSeconds = calculateWorkTime(time_intervals);
	const total = formatSecondsToTime(totalSeconds, "hm");

	return { range, total };
};

const MobileShiftCard = ({ assignment, employee, showAvatar = true }) => {
	const shift = assignment.shift;
	const func = assignment.function;
	const { range, total } = getTimeRange(assignment);

	const ubication =
		assignment.ubications && assignment.ubications.length > 0
			? assignment.ubications[0]
			: employee?.employee_with_ubication?.ubication || null;

	const employeeName = `${employee.name} ${employee.surname}`;
	const functionName = func
		? func.name
		: employee?.employee_with_function?.function?.name || "";

	const shiftColor = shift.background_color || "#5b49fe";

	return (
		<div className="mobile-shift-card">
			<div
				className="mobile-shift-card__color-bar"
				style={{ backgroundColor: shiftColor }}
			/>
			<div className="mobile-shift-card__content">
				<div className="mobile-shift-card__main">
					{showAvatar && (
						<div className="mobile-shift-card__avatar">
							<Avatar
								userId={employee.id}
								className="avatar-xs"
								alt={employeeName}
							/>
						</div>
					)}
					<div className="mobile-shift-card__info">
						<span className="mobile-shift-card__name">{employeeName}</span>
						{functionName && (
							<span className="mobile-shift-card__function">{functionName}</span>
						)}
					</div>
					<div className="mobile-shift-card__right">
						<span className="mobile-shift-card__shift-name">
							{shift.name.substring(0, 3).toUpperCase()}
						</span>
						{total && (
							<span className="mobile-shift-card__total">{total}</span>
						)}
					</div>
				</div>
				<div className="mobile-shift-card__details">
					{range && (
						<span className="mobile-shift-card__time">
							<FiCalendar size={13} />
							{range}
						</span>
					)}
					{ubication && (
						<span className="mobile-shift-card__location">
							<FiMapPin size={13} />
							{ubication.name}
						</span>
					)}
				</div>
			</div>
		</div>
	);
};

export default MobileShiftCard;
